module.exports = __webpack_public_path__ + "img/volkswagen_thumbnail.f5d0a6b4.png";